import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import {router, store} from "@/router";
import Vuex from "vuex";

Vue.config.productionTip = false

Vue.use(Vuex);

new Vue({
    el: '#app',
    store,
    router,
    vuetify,
    render: h => h(App)
});
